import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';
import { formatImage } from '@ifeng/public_method';
import { getFengListData } from '../../../../../services/api';
import { getCommentNum } from '../../../../../utils/getCommentNum';

const WemediaRec = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
            recQrData: PropTypes.object,
        };

        state = {
            recommendNews: [],
        };

        async componentDidMount() {
            const {
                content: { wemediaEAccountId },
            } = this.props;

            if (wemediaEAccountId) {
                const listData = await getFengListData(wemediaEAccountId);

                if (listData.code === 0 && Object.prototype.toString.call(listData.data)) {
                    const withComments = await getCommentNum(listData.data);

                    this.setState({
                        recommendNews: withComments,
                    });
                }
            }
        }

        render() {
            const {
                content: { wemediaEAccountId, wemediaEAccountDesc, wemediaEAccountHead, source },
                recQrData: { img, desc },
            } = this.props;

            const { recommendNews } = this.state;

            const wemediaHomePageUrl = `//feng.ifeng.com/author/${wemediaEAccountId}`;

            return (
                <div className={styles.recommendBox}>
                    <div className={styles.wemediaLine}>
                        <div className={styles.yc_intro_l}>
                            <div className={styles.yc_intro_l_wemedia}>
                                <a href={wemediaHomePageUrl} target="_blank" rel={rel}>
                                    <img src={wemediaEAccountHead} alt="" />
                                </a>
                                <p>
                                    <a href={wemediaHomePageUrl} target="_blank" rel={rel}>
                                        {wemediaEAccountDesc}
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div className={styles.yc_intro_r}>
                            <img src={formatImage(img, 80, 80)} />
                            <div className={styles.desc_fl}>
                                {Object.prototype.toString.call(desc)
                                    ? desc.map((item, index) => (
                                          <p key={index} className={index === 0 ? styles.firstLine : null}>
                                              {item}
                                          </p>
                                      ))
                                    : null}
                            </div>
                        </div>
                    </div>
                    <div className={styles.recNewsBox}>
                        <div className={styles.leftName}>
                            <h4>凤凰精品</h4>
                            <p>{source}</p>
                        </div>
                        <div className={styles.right_list}>
                            {recommendNews.map((item, index) => (
                                <div className={styles.rec_line} key={index}>
                                    {item.thumbnail ? (
                                        <a href={item.url} target="_blank" rel={rel} className={styles.thumbnailBox}>
                                            <img src={item.thumbnail} />
                                        </a>
                                    ) : null}
                                    <div className={styles.newsContent}>
                                        <h4>
                                            <a href={item.url} target="_blank" rel={rel}>
                                                {item.title}
                                            </a>
                                        </h4>
                                        <p>
                                            <span className={styles.rec_time}>{item.newsTime || ''}</span>
                                            <span className={styles.rec_commentNum}>{item.commentsNum || 0}</span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                            <a
                                className={styles.getMore}
                                href={`//feng.ifeng.com/author/${wemediaEAccountId}`}
                                target="_blank"
                                rel={rel}>
                                查看更多新闻
                            </a>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export default WemediaRec;
